import React, { useState, useEffect, Fragment } from 'react';

//import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import Post from "./Post";
import Header from "./Header";
import LeftCard from "../components/LeftCard";
import Footer from "./Footer";
import {
    Button,
    Alert,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText,
} from "react-bootstrap";

import "./WordByWordUpdate.css";
import "./bubble.css";
//import logo from "./sethu.ai_1.jpg";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { AppBar, Link, Toolbar, Typography } from "@mui/material";
import { ThemeProvider } from '@mui/material'

function WordByWordUpdateIns() {
    const [item, setItems] = useState([])
    const [text, setText] = useState('Hello World');
    const [message, setMessage] = useState('');
    const [qmessage, setQMessage] = useState('what medical insurance plans available?');
    const [displayedText, setDisplayedText] = useState('');
    const [loading, setLoading] = useState(false);


    const addItem = (qmessage, displayedText) => {
        //const newItem = `Item ${items.length + 1}`;
        setItems(prevItems => [...prevItems, { qmessage, displayedText }]);
    };

    /*useEffect(() => {
        const updateTextWithDelay = async () => {
            const words = message.split(' ');

            for (const word of words) {
                // Simulate a delay using setTimeout
                await sleep(150); // Adjust the delay time as needed

                // Update the displayedText state word by word
                setDisplayedText((prevText) => prevText + ' ' + word);
            }
        };

        updateTextWithDelay();
    }, [text]);*/

    //useEffect(() => {
    const updateTextWithDelay = async () => {
        const words = message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        addItem("<Employee >" + qmessage, message)

    };
    const aupdateTextWithDelay = async (a_message) => {
        const words = a_message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        //addItem("<Employee >" + qmessage, "<Insurance Bot >" + a_message)
        addItem(" " + qmessage, " " + a_message);
        setLoading(false);

    };

    //    updateTextWithDelay();
    //}, [text]);
    useEffect(() => {
        const interval = setInterval(() => {

            setDisplayedText(prevText => prevText.includes('Loading') ? prevText + '.' : prevText);

        }, 500);

        return () => clearInterval(interval);
    }, []);

    // Utility function to simulate sleep
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const handleSendMessage = () => {
        setMessage("");
        setLoading(true);
        setDisplayedText("Loading");
        //fetch("http://127.0.0.1:5000/get_response/?question=" + qmessage)
        //fetch("http://127.0.0.1:5000/openapi_get_response/?question=" + qmessage)  
        //fetch("http://127.0.0.1:5000/get_response/?question=" + qmessage)
        fetch("http://157.173.222.203:8080/api_call/?query=" + qmessage)
            .then((response) => response.json())
            .then((data) => {

                //setMessage("<Customer>" + qmessage + "[SEP]<BOT>" + data.response);
                //setMessage("<BOT>" + data.response);
                setMessage(" " + data.response);
                //console.log(message);
                //this.setState({ message: "" });
                //updateTextWithDelay();
                setDisplayedText("");
                aupdateTextWithDelay(data.response);
                //setQMessage('');
                //setMessage('');

            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });

    };
    const handleInputChange = (e) => {
        setQMessage(e.target.value);
        setDisplayedText('');
        //console.log(qmessage)
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <div className='fillOutPage property'>
                <Header />

                {/* <main className="my-5 py-5"> */}
                <Container className="px-0">
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">
                        <Card>
                            <Typography variant="h5" style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                                LLM based BOT Application for Insurance Domain

                            </Typography>

                        </Card>
                    </Row>
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">
                        <div className="App">
                            {loading ? (<Card>
                                <div class="middle">
                                    {/* <p class="left-align">{" " + qmessage}</p> */}
                                    <p class="left-align">{" " + displayedText}</p>
                                </div>
                            </Card>) : (<Card>
                                <div className="center">

                                    <ul className="message-list">
                                        {item.map((imessage, index) => (
                                            <Fragment key={index}>
                                                <p className="right-align chat-bubble user">{imessage.qmessage}</p>
                                                <p className="left-align chat-bubble bot">{imessage.displayedText}</p>
                                            </Fragment>
                                        ))}
                                        {/* {item.map((imessage, index) => (
                                    <p class="left-align" key={index}>{imessage}</p>
                                ))} */}
                                    </ul>
                                </div>
                            </Card>
                            )}

                            <Card>
                                <div className="center1">
                                    <div>
                                        <input
                                            className="resizedTextbox"
                                            type="text"
                                            id="fname"
                                            placeholder="Type your Question Here..."
                                            onChange={handleInputChange}
                                            value={qmessage}
                                            onKeyPress={handleKeyPress} // Listen for Enter key press
                                            name="fname" />
                                        <button className='bg-secondary send-btn resizedbutton' onClick={handleSendMessage}>Send</button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Row>

                </Container>
                {/* </main> */}
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default WordByWordUpdateIns;




